<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div [style.margin]="'0px 0px -6.5px 0px'">
      <img src="https://wikipapa.org/images/banner-miski1.jpg" style="object-fit: contain; background-size: cover"
        width="100%" />
    </div>

    <div [style.margin]="'0px 0px -6.5px 0px'">
      <img src="https://wikipapa.org/images/banner-miski2.jpg" style="object-fit: contain; background-size: cover"
        width="100%" />
    </div>
    <br /><br />
    <div style="max-width: 1400px; margin: 0px auto" [style.background-color]="'#fff'">
      <div [style.margin]="'0px 0px -6.5px 0px'">
        <a href="https://linktr.ee/miski.papa">
          <img src="https://wikipapa.org/images/banner-miski3.jpg" style="object-fit: contain; background-size: cover"
            width="100%" />
        </a>
      </div>
    </div>
    <br /><br />
    <div style="max-width: 1170px; margin: 0px auto; padding: 15px" [style.background-color]="'#fff'">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div [style.margin]="'0px 0px -6.5px 0px'">
          <img src="https://wikipapa.org/images/comercio1.jpg" style="object-fit: contain; background-size: cover"
            width="100%" />
        </div>

        <div [style.margin]="'0px 0px -6.5px 0px'">
          <img src="https://wikipapa.org/images/comercio2.jpg" style="object-fit: contain; background-size: cover"
            width="100%" />
        </div>

        <div [style.margin]="'0px 0px -6.5px 0px'">
          <img src="https://wikipapa.org/images/comercio3.jpg" style="object-fit: contain; background-size: cover"
            width="100%" />
        </div>
      </div>
    </div>
  </div>
</div>